import { useState } from 'react';
import ExploreContentWrapper from '../explorecontentwrapper/ExploreContentWrapper';
import ExploreSearchSidebar from '../exploresearchsidebar/ExploreSearchSidebar';
import ExploreDataWrapper from '../exploredatawrapper/ExploreDataWrapper';
import ExploreMobileSortFilter from '../exploremobilesortfilter/ExploreMobileSortFilter';

import classes from './ExploreSearchWrapper.module.scss';
import ExploreSearchResultTitle from './exploresearchresulttitle/ExploreSearchResultTitle';

const ExploreSearchWrapper = ({
	filters,
	searchData: {
		searchKeyword,
		selectedCategories,
		selectedContent,
		selectedOrdering,
		selectedCareerPath,
		selectedPrice,
		selectedProficiency,
		selectedPage,
		selectedHighlighted,
	},
	handleCategoryClick,
	handlePriceClick,
	handleProficiencyClick,
	handleQueryKeywordChange,
	handleContentTypeSelect,
	handleOrderingChange,
	handleCareerPathChange,
	handlePageChange,
	handleHighlightedChange,
}) => {

	const [resultCount, setResultCount] = useState();

	return (
		<div
			className={`${classes['explore-search-wrapper']} d-flex flex-column gap-3 my-3 my-lg-5 align-items-center`}>
			{/* <h1 className="container">Explore All</h1> */}
			{searchKeyword && (
				<ExploreSearchResultTitle searchKeyword={searchKeyword} resultCount={resultCount} />
			)}
			<div className="w-100 d-block d-lg-none">
				<ExploreMobileSortFilter
					filters={filters}
					searchKeyword={searchKeyword}
					selectedCategories={selectedCategories}
					selectedPrice={selectedPrice}
					selectedProficiency={selectedProficiency}
					selectedCareerPath={selectedCareerPath}
					handleCategoryClick={handleCategoryClick}
					handlePriceClick={handlePriceClick}
					handleProficiencyClick={handleProficiencyClick}
					handleQueryKeywordChange={handleQueryKeywordChange}
					selectedContent={selectedContent}
					handleContentTypeSelect={handleContentTypeSelect}
					selectedOrdering={selectedOrdering}
					handleOrderingChange={handleOrderingChange}
					selectedHighlighted={selectedHighlighted}
					handleHighlightedChange={handleHighlightedChange}
					handleCareerPathChange={handleCareerPathChange}
				/>
			</div>
			<div className="container row gap-4">
				<div className="d-none d-lg-block col-lg-4 col-xl-4">
					<ExploreSearchSidebar
						filters={filters}
						searchKeyword={searchKeyword}
						selectedCategories={selectedCategories}
						selectedPrice={selectedPrice}
						selectedProficiency={selectedProficiency}
						selectedHighlighted={selectedHighlighted}
						selectedCareerPath={selectedCareerPath}
						handleCategoryClick={handleCategoryClick}
						handlePriceClick={handlePriceClick}
						handleProficiencyClick={handleProficiencyClick}
						handleQueryKeywordChange={handleQueryKeywordChange}
						handleHighlightedChange={handleHighlightedChange}
						handleCareerPathChange={handleCareerPathChange}
					/>
				</div>
				<div className="col-12 col-lg-7 col-xl-7 d-flex flex-column gap-4">
					<div className="d-none d-lg-block">
						<ExploreContentWrapper
							selectedContent={selectedContent}
							handleContentTypeSelect={handleContentTypeSelect}
							selectedOrdering={selectedOrdering}
							handleOrderingChange={handleOrderingChange}
							resultCount={resultCount}
						/>
					</div>
					<ExploreDataWrapper
						handlePageChange={handlePageChange}
						selectedPage={selectedPage}
						setResultCount={setResultCount}
					/>
				</div>
			</div>
		</div>
	);
};

export default ExploreSearchWrapper;
